import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold border",
  {
    variants: {
      variant: {
        gray: "bg-secondary text-muted-foreground border-transparent",
        blue: "bg-[color:var(--badge-blue-bg)] text-[color:var(--b-blue)] border-transparent",
        green: "bg-[color:var(--badge-green-bg)] text-[color:var(--b-green)] border-transparent",
        amber: "bg-[color:var(--badge-amber-bg)] text-[color:var(--b-amber)] border-transparent",
        red: "bg-[color:var(--badge-red-bg)] text-[color:var(--b-red)] border-transparent",
      },
    },
    defaultVariants: { variant: "gray" },
  }
);

export type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>["variant"]>;

export function Badge({ className, variant, ...props }: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant, className }))} {...props} />;
}

// map billing status -> badge color
export function statusVariant(status: string): BadgeVariant {
  switch (status) {
    case "Paid": return "gray";
    case "Invoiced": return "green";
    case "Ready for finance": return "blue";
    case "Needs review": return "amber";
    case "Needs backup": return "red";
    default: return "gray";
  }
}
